import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
const SearchModule = ({setSearchText, seacrhText, setSearchType, searchType}) => {
	const {
			loggedInUser,
			defaultChildData,
		} = useSelector((state) => state.collections);
	
  	const [isSearch, setIsSearch] = useState();
  	const hadnleSearch = (type) => {
			setIsSearch(type);
			if (!type) {
				setSearchText("");
				setSearchType("");
			}
	};

	useEffect(()=>{
		if(loggedInUser?.role?.name === "LEARNER"){
			setIsSearch(true);
		}
	},[loggedInUser])
	
	const handleSeach = (e) => {
		const value = e.target.value.trimStart();
		setSearchText(value);
	}

	const handleSearchByTag = (type)=>{
		setSearchType(type);
		setSearchText("");
	}
  return (
	  <div className={`${isSearch ?"searchtag":"searchtag notsearchdropdown "} flexthree  ml-auto  ${searchType}`}>
	   {isSearch && (
		<>
	   <div className={`searchdropdown`}>
		<span
			 aria-haspopup="true"
			data-toggle="dropdown"
            id="searchmytaxt"
			aria-expanded="false"
		>
			{!searchType ? "All" : searchType} 
			<i class="fa-light fa-chevron-down"></i>
		</span>
		<ul className="dropdown-menu planname_list  dropdown-menu-end"
			aria-labelledby="searchmytaxt"
		>
			<li onClick={()=>handleSearchByTag("")}><p className="p1">All</p></li>
			<li onClick={()=>handleSearchByTag("Courses")}><p className="p1">Courses</p></li>
			<li onClick={()=>handleSearchByTag("Dimension")}><p className="p1">Dimension</p></li>
			<li onClick={()=>handleSearchByTag("Plan")}><p className="p1">Plan</p></li>
			<li onClick={()=>handleSearchByTag("Skill")}><p className="p1">Skill</p></li>
		</ul>
	  </div>
		  
		 <input
				  type="text"
				  placeholder="Search"
				  className=""
				  value={seacrhText}
				  onChange={(e) => handleSeach(e)} 
				  
			  />
			  </>
		  )}
     
		{!isSearch ? (
			  <span key={Math.random()} className="search_icons pointer" onClick={()=>hadnleSearch(true)}>	
			  <i class="fa-light fa-magnifying-glass"></i>
			</span>
		  ) : (
			<span key={Math.random()} className="search_icons  pointer" onClick={()=>hadnleSearch(false)}>
				<i class="fa-regular fa-xmark"></i>
			</span>	  
			
				  
		)}
   
    </div>
  );
};
export default SearchModule;
